import { useStaticQuery, graphql } from "gatsby";
import { keysToCamel } from "@utils";
import resolveImageData from "../dataResolvers/resolveImageData";
import resolveByPrefix from "../dataResolvers/resolveByPrefix";
import mergePrismicPreview from "../mergePrismicPreview";

const query = graphql`
  query HomePageQuery {
    prismicHomePage {
      data {
        meta_title
        meta_description
        meta_image {
          filter
          focal_point_x
          focal_point_y
          image {
            alt
            url
            dimensions {
              height
              width
            }
          }
        }
        prefooter_cta_link {
          url
          target
        }
        prefooter_cta_text
        prefooter_description {
          html
        }
        prefooter_heading
        prefooter_background_image {
          filter
          focal_point_x
          focal_point_y
          image {
            alt
            url
            dimensions {
              height
              width
            }
          }
        }
      }
    }
  }
`;

const dataResolver = ({ prismicHomePage }) => {
  const { prefixed } = resolveByPrefix(prismicHomePage.data, [
    "meta_",
    "prefooter_",
  ]);
  const { prefooter, meta } = prefixed;

  const resolved = {
    meta: {
      ...meta,
      image: resolveImageData(meta.image)[0],
    },
    prefooter: {
      ...prefooter,
      backgroundImage: resolveImageData(prefooter.background_image)[0],
    },
  };

  return keysToCamel(resolved);
};

const useHomePageData = () => {
  const response = useStaticQuery(query);
  const data = mergePrismicPreview(response);
  return dataResolver(data);
};

export default useHomePageData;
